<script>
import demo from './Template/index'

export default {
  ...demo,
  data () {
    const demoData = demo.data()
    return {
      ...demoData,
      tab: 'LotOversea'
    }
  }
}
</script>
